import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/spinner/spinner.js'

const tagName = 'dap-ds-spinner'

/**
 * `dap-ds-spinner`
 * @summary Loading spinner component.
 * @element dap-ds-spinner
 * @title - Spinner
 *
 * @csspart base - The main spinner container.
 * @csspart icon - The loading icon element.
 * @csspart icon-base - The base of the loading icon.
 * @csspart icon-content - The content of the loading icon.
 * @csspart text - The loading text element.
 *
 * @slot - The loading text content.
 * @slot icon - The loading icon content.
 *
 * @cssprop --dds-spinner-icon-color-neutral - Color for neutral spinner icons (default: var(--dds-icon-neutral-base))
 * @cssprop --dds-spinner-icon-color-brand - Color for brand spinner icons (default: var(--dds-icon-brand-subtle))
 * @cssprop --dds-spinner-icon-color-negative - Color for negative spinner icons (default: var(--dds-icon-negative-subtle))
 * @cssprop --dds-spinner-icon-color-positive - Color for positive spinner icons (default: var(--dds-icon-positive-subtle))
 * @cssprop --dds-spinner-icon-color-inverted - Color for inverted spinner icons (default: var(--dds-icon-neutral-inverted))
 * @cssprop --dds-spinner-text-spacing - Spacing between spinner and text (default: var(--dds-spacing-400))
 * @cssprop --dds-spinner-animation-duration - Duration of the spinner animation (default: 1s)
 *
 * @property { 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' } size - The size of the spinner. Default is `lg`. See SizedMixin.
 * @property {string} sizeMap - Responsive size map (e.g. "md:lg"); see SizedMixin.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSSpinner',
})

export default reactWrapper
